import { SignatureRow } from 'components/tables/data/signature/types';
import DateDisplay from 'components/DateDisplay';

/**
 * Column for the document valid until date.
 */
export default function DocumentValidUntilColumn({ data }: { data: SignatureRow }) {
  if (!data.documentValidUntil) {
    return null;
  }

  return <DateDisplay date={new Date(data.documentValidUntil)} />;
}
